import { DtoLoginResponse } from "../catadmin/InternalCatalogueAPI";
import * as ls from "./localStorage";

// export interface ErrorResponse {
// 	error: string;
// }

// export interface SuccessResponse {
// 	success: string;
// }

// export interface UserResponse {
// 	user: User;
// }

// export interface UsersResponse {
// 	users: User[];
// }

// export interface LoginResponse extends AuthorizeResponse {
// 	adminToken?: string;
// 	tokenExpires: string;
// 	user: User;
// }

export interface Feature {
	cr: string;
	deleted: string | null;
	description: string;
	id: number;
	key: string;
	mo: string;
	title: string;
}

// export interface FeaturesResponse {
// 	features: Feature[];
// }

// export interface JobsResponse {}

// export interface LoginRequest {
// 	email: string;
// 	password: string;
// }

// export interface FeatureForm {
// 	description: string;
// 	id?: number;
// 	key: string;
// 	title: string;
// }

// interface UserFeatureFlag {
// 	key: string;
// 	uid: number;
// }

// // POST

// interface PostRequests {
// 	"admin/features/add-user": UserFeatureFlag;
// 	"admin/features/new": FeatureForm;
// 	"admin/features/remove-user": UserFeatureFlag;
// 	"admin/features/update": FeatureForm;
// 	"admin/job": {};
// 	login: LoginRequest;
// 	logout: {};
// }

// interface PostResponses {
// 	"admin/features/add-user": SuccessResponse;
// 	"admin/features/new": SuccessResponse;
// 	"admin/features/remove-user": SuccessResponse;
// 	"admin/features/update": SuccessResponse;
// 	"admin/job": RenderJobResponse;
// 	login: LoginResponse;
// 	logout: SuccessResponse;
// }

// type PostEndpoint = keyof PostResponses & keyof PostRequests;

// // GET

// interface GetRequests {
// 	"admin/features/users/:1": [string];
// 	"admin/features": undefined;
// 	"admin/job": undefined;
// 	user: undefined;
// }

// interface GetResponses {
// 	"admin/features/users/:1": UsersResponse;
// 	"admin/features": FeaturesResponse;
// 	"admin/job": RenderJobsResponse;
// 	user: UserResponse;
// }

// type GetEndpoint = keyof GetRequests & keyof GetResponses;

// async function fetchJSON<T = any>(url: string, options?: RequestInit): Promise<T> {
// 	const response = await fetch(url, options);
// 	const text = await response.text();
// 	return JSON.parse(text);
// }

// const SESSION_API_URL_KEY = "session_api_url";
// const SESSION_FEATURES_KEY = "session_features";
// const SESSION_PERMISSIONS_KEY = "session_permissions";
// const SESSION_TOKEN_KEY = "session_token";
// const SESSION_EXPIRES_KEY = "session_expires";
// const SESSION_USER_KEY = "session_user";
// const SESSION_ADMIN_TOKEN_KEY = "session_admin_token";

// const baseURL = process.env.REACT_APP_CATADMIN_URL || "/api/v1";

// async function post<K extends PostEndpoint>(
// 	adminToken: string,
// 	endpoint: K,
// 	data: PostRequests[K]
// ) {
// 	const url = `${baseURL}/${endpoint}`;

// 	const options: RequestInit = {
// 		body: JSON.stringify(data),
// 		headers: new Headers({
// 			"Content-Type": "application/json; charset=utf-8",
// 			"X-API-Key": adminToken || "",
// 		}),
// 		method: "POST",
// 		mode: "cors",
// 	};

// 	const response = await fetchJSON<PostResponses[K] | ErrorResponse>(url, options);

// 	if ("error" in response) {
// 		throw Error(response.error);
// 	} else {
// 		return response;
// 	}
// }

// async function get<K extends GetEndpoint>(
// 	adminToken: string,
// 	endpoint: K,
// 	reqParams?: GetRequests[K]
// ) {
// 	let url = `${baseURL}/${endpoint}`;

// 	if (reqParams) {
// 		url = reqParams.reduce((prev, current, index) => {
// 			return prev.replace(`:${index + 1}`, current);
// 		}, url);
// 	}

// 	const options: RequestInit = {
// 		headers: new Headers({
// 			"X-API-Key": adminToken || "",
// 		}),
// 		method: "GET",
// 		mode: "cors",
// 	};

// 	const response = await fetchJSON<GetResponses[K] | ErrorResponse>(url, options);

// 	if ("error" in response) {
// 		throw Error(response.error);
// 	} else {
// 		return response;
// 	}
// }

// export class AdminAPI {
// 	public adminToken = "";

// 	async post<K extends PostEndpoint>(endpoint: K, data: PostRequests[K]) {
// 		return post(this.adminToken, endpoint, data);
// 	}

// 	async get<K extends GetEndpoint>(endpoint: K, reqParams?: GetRequests[K]) {
// 		return get(this.adminToken, endpoint, reqParams);
// 	}

// 	async login(req: LoginRequest) {
// 		const res = await post("", "login", req);
// 		this.adminToken = res.adminToken || "";
// 		ls.set(SESSION_ADMIN_TOKEN_KEY, res.adminToken || "");
// 		ls.set(SESSION_API_URL_KEY, res.endpoint);
// 		ls.set(SESSION_EXPIRES_KEY, res.tokenExpires);
// 		ls.set(SESSION_TOKEN_KEY, res.secretToken);
// 		ls.setJSON(SESSION_PERMISSIONS_KEY, res.session.permissions || []);
// 		ls.setJSON(SESSION_USER_KEY, res.user);
// 		ls.setJSONArray(SESSION_FEATURES_KEY, res.session.features || []);
// 		return res;
// 	}

// 	async logout() {
// 		ls.clear();
// 		return post(this.adminToken, "logout", {});
// 	}

// 	async updateUser() {
// 		const res = await get(this.adminToken, "user", undefined);
// 		ls.setJSON(SESSION_USER_KEY, res.user);
// 		return res;
// 	}
// }

export const CACHE_KEY_LOGIN = "cache_login_response_v0";

export function cacheLoginResponse(res: DtoLoginResponse) {
	ls.setJSON(CACHE_KEY_LOGIN, res);
}

export function getFeaturesFromLogin() {
	const login: DtoLoginResponse | undefined = ls.getJSON(CACHE_KEY_LOGIN);
	if (login === undefined) {
		return [];
	}

	return login.session.features || [];
}

export function loginOffline(): DtoLoginResponse | undefined {
	try {
		const loginResponse: DtoLoginResponse | undefined = ls.getJSON(CACHE_KEY_LOGIN);

		if (loginResponse === undefined) {
			return;
		}

		if (Date.parse(loginResponse.session.expires) < Date.now()) {
			ls.clear();
			return;
		}

		return loginResponse;
	} catch (e) {
		console.error("could not load login response from cache", e);
		ls.clear();
	}
}
